export default __webpack_public_path__ + "static/media/nitron_3.5ede96fd.jpg";